import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import {
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { useGetCreditorAccountListingLazyQuery } from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router-dom'

interface PayeeDetailsListingProps {
  pageMode: 'active' | 'inactive'
}

export const PayeeDetailsListing = (props: PayeeDetailsListingProps) => {
  const { pageMode } = props
  let history = useHistory()
  const { BankEFTID }: any = useParams()
  const { filteredList, setOriginalListing, handleSearch } = useFuseSearch()
  const getSearch = localStorage?.getItem('payeeDetailsFilter')

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [totalLength, setTotalLength] = useState(0)
  const rawFetchCount = useRef(0)
  const searchValueRef = useRef(getSearch ?? '')
  const statusFilter = pageMode === 'active' ? 'ACTIVE' : 'INACTIVE'

  const [
    loadData,
    { loading: CreditorAccountLoading },
  ] = useGetCreditorAccountListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getCreditorAccount, getCreditorAccountCount }) => {
      if (getCreditorAccount?.length > 0) {
        rawFetchCount.current += getCreditorAccount.length
        const filtered = getCreditorAccount
          .filter(el => el?.CreditorStatus === statusFilter)
          .sort((a, b) => a.CompanyName.localeCompare(b.CompanyName))
        setOriginalListing([...filteredList, ...filtered])
      }
      if (!!getCreditorAccountCount) setTotalLength(getCreditorAccountCount)
    },
  })

  useEffect(() => {
    rawFetchCount.current = 0
    loadData({
      variables: {
        orderByAsc: 'CompanyName',
        skip: 0,
        take: 30,
        ...(getSearch && { searchValue: getSearch }),
      },
    })
  }, [])

  const navigateToForm = (creditorAccountID: string) => {
    history.push(`/bank-eft/${BankEFTID}/payee-details/${creditorAccountID}`)
  }

  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        searchValueRef.current = change
        setOriginalListing([])
        rawFetchCount.current = 0
        loadData({
          variables: {
            orderByAsc: 'CompanyName',
            skip: 0,
            take: 30,
            searchValue: change,
          },
        })
      }, 1000)
    )
  }

  return (
    <>
      <div className="search-filter">
        <SearchHeader
          title="Search here.."
          search
          onChangeAction={e => {
            localStorage.setItem('payeeDetailsFilter', e.target.value)
            changeDelay(e.target.value)
          }}
          onCloseAction={() => {
            handleSearch('', [])
            localStorage.removeItem('payeeDetailsFilter')
            searchValueRef.current = ''
            setOriginalListing([])
            rawFetchCount.current = 0
            loadData({
              variables: {
                orderByAsc: 'CompanyName',
                skip: 0,
                take: 30,
              },
            })
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch ? getSearch : ''}
        />
      </div>
      <ContentWrapper float>
        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                loadData({
                  variables: {
                    orderByAsc: 'CompanyName',
                    skip: rawFetchCount.current,
                    take: 30,
                    ...(searchValueRef.current && {
                      searchValue: searchValueRef.current,
                    }),
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                CreditorAccountLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {filteredList?.map((el, index) => {
                return (
                  <ListItem
                    key={index}
                    onClick={() => navigateToForm(el?.CreditorAccountID)}
                  >
                    <ListItemText
                      primary={
                        <>
                          <span className="xsTitle flex-space">
                            {el?.CompanyName}
                          </span>
                        </>
                      }
                      secondary={
                        <>
                          <span className="desc">{el?.PayeeName}</span>
                          {el?.BankAccountNo && (
                            <span className="desc">
                              {` | ${el?.BankName} - ${el?.BankAccountNo}`}
                            </span>
                          )}
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="arrow"
                        onClick={() => navigateToForm(el?.CreditorAccountID)}
                      >
                        <KeyboardArrowRight />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
